export default __webpack_public_path__ + "static/img1-eb8d389ea037b48bfe0e0cf8461c9486.png";